module.exports = __webpack_public_path__ + "static/media/shenqingshiyongi_140.74caf2cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/about/shenqingshiyongi_140.svg
// module id = 678
// module chunks = 0